import { combineReducers } from 'redux';
import customizer from 'redux/reducers/customizer/customizer';

const customizerReducer = combineReducers({
  customizer,
});

export default customizerReducer;
